import React, { useState } from 'react';
import Modal from 'react-modal';
import signupmodal from '../../assets/frontendpage/signupstudent/signupmodal.svg'
import signupmodal2 from '../../assets/frontendpage/signupstudent/signupmodal2.png'
import { useNavigate } from 'react-router-dom';
import styles from './style/signupmodal.module.css'

const customStyles = {
  overlay: {
    backgroundColor: "rgba(30, 20, 70, 0.55)",
    backdropFilter: "blur(6px)",
    zIndex: 10000,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    border: "none",
    borderRadius: "20px",
    padding: "32px 28px",
    maxWidth: "min(480px, calc(100vw - 32px))",
    boxShadow: "0 28px 64px rgba(74, 52, 181, 0.22)",
    animation: "fadeSlideUp 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
  },
};

const SignupModal = ({ isOpen, onRequestClose }) => {

  const [imageSrc, setImageSrc] = useState(signupmodal);
  const [hoveredButton, setHoveredButton] = useState(null);
  const navigate = useNavigate();

  const handleSignupClick = () => {
    onRequestClose?.();
    navigate("/signup-as-student");
  };

  const handlesignuptutor = () => {
    onRequestClose?.();
    navigate("/signup-as-tutor");
  };

  const handleTutorMouseEnter = () => {
    setImageSrc(signupmodal2);
    setHoveredButton('tutor');
  };

  const handleTutorMouseLeave = () => {
    setImageSrc(signupmodal);
    setHoveredButton(null);
  };

  const handleStudentMouseEnter = () => {
    setHoveredButton('student');
  };

  const handleStudentMouseLeave = () => {
    setHoveredButton(null);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      ariaHideApp={false}
      contentLabel="Register Modal"
    >
      <div style={{'display':'flex', 'flexDirection':'column', 'alignItems':'center', 'gap':'10px'}}>
        <img src={imageSrc} alt="Register" className={styles.modalImage}/>
        <button className={`${styles.signupStudent} ${hoveredButton === 'tutor' ? styles.inactiveButton : ''}`} onClick={handleSignupClick} onMouseEnter={handleStudentMouseEnter} onMouseLeave={handleStudentMouseLeave}> Register as a Student </button>
        <button className={`${styles.signupTutor} ${hoveredButton === 'tutor' ? styles.activeButton : ''}`} onClick={handlesignuptutor} onMouseEnter={handleTutorMouseEnter} onMouseLeave={handleTutorMouseLeave}> Register as a Tutor </button>
      </div>
    </Modal>
  );
};

export default SignupModal;
